module.exports = __webpack_public_path__ + "static/img/level-card-banner1.752de6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/8/level-card-banner1.png
// module id = M4AN
// module chunks = 1